import { Box, Typography } from "@mui/material"
import React from "react"
import EmptyPlaceHolderImg from "../../../../../../../assets/img/building-empty-placeholder.png"

interface IProps {
  title: string
}

export function EmptyPlaceHolder({ title }: Readonly<IProps>): React.JSX.Element {
  return (
    <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" p={1}>
      <Box
        component="img"
        src={EmptyPlaceHolderImg}
        sx={{
          width: "250px",
          height: "250px",
          objectFit: "cover",
          mb: 1,
        }}
      />
      <Typography variant="subtitle2">{title}</Typography>
    </Box>
  )
}
